module.exports = __webpack_public_path__ + "static/media/multipleMob.ba32866a.png";